import QUERY_KEYS from '@/constants/queryKeys';
import { api } from '@/services/burrbear-api/api.client';
import { useQuery } from '@tanstack/vue-query';
import useNetwork from '../useNetwork';

export interface CuratedPoolsData {
  curatedPools: string[];
}

export default function useCuratedPoolsQuery() {
  const { networkId } = useNetwork();

  const queryKey = QUERY_KEYS.Pools.Curated(networkId);

  const queryFn = async (): Promise<CuratedPoolsData> => {
    try {
      const { curatedPools } = await api.GetCuratedPools();
      return {
        curatedPools: curatedPools.map(pool => pool.address.toLowerCase()),
      };
    } catch (error) {
      console.error('Failed to fetch curated pools', error);
      return {
        curatedPools: [],
      };
    }
  };

  return useQuery<CuratedPoolsData>(queryKey, queryFn, {
    staleTime: 30 * 1000, // Data stays fresh for 30 seconds
    cacheTime: 5 * 60 * 1000, // Cache persists for 5 minutes
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data is still fresh
  });
}
